import React from 'react'
import Button from 'react-bootstrap/Button'

function Buuton({text}) {
    return (
        <>
            <style type="text/css">
            {`
                .btn-flat {
                    background-color: #17b978;
                    color: #fc5185;
                }

                .btn-xxl {
                    padding: 1rem 1.5rem;
                    font-size: 1.7rem;
                }
            `}
            </style>

            <Button variant="flat" size="xxl">{text}</Button>
        </>
    )
}

export default Buuton
